define(["jquery"], ($) => {
  class GeneralBBNTLoader {
    /**
     * Constructor
     *
     * @param {Object}  config  Configuration options passed in through JSON
     * @param {Element} element The element that this class was bound to
     *
     * @returns {null}
     */
    constructor(config, element) {
      const defaultConfig = {};

      this.config = { ...defaultConfig, ...config };

      this.$element = $(element);

      this.attachListeners();
    }

    attachListeners() {
      const _self = this;

      this.$element.on("bbntGeneralLoadBegin", function () {
        _self.onBeginLoading();
      });

      this.$element.on("bbntGeneralLoadEnd", function () {
        _self.onEndLoading();
      });
    }

    onBeginLoading() {
      this.render();
    }

    onEndLoading() {
      this.derender();
    }

    render() {
      const loaderHtml = `
        <div class="react-plp-loading__block react-plp-loading__block--is-active">
          <div class="react-plp-loading__spinner"></div>
        </div>
      `;

      const $loaderElement = $(loaderHtml);

      $loaderElement.prependTo(this.$element);
    }

    derender() {
      const $loaderElement = $("body > .react-plp-loading__block.react-plp-loading__block--is-active");
      if ($loaderElement) {
        $loaderElement.remove();
      }
    }
  }

  return (config, element) => {
    const generalBBNTLoader = new GeneralBBNTLoader(config, element);
    return generalBBNTLoader;
  };
});
